import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=c4c0de74&"
import script from "./AddClass.vue?vue&type=script&lang=js&"
export * from "./AddClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports